<template>
    <!--<Vue3Marquee :pause-on-hover="true" :duration="40" class="ms-3 me-3">
        <div
            v-for="notification in notifications"
            class="card me-2 mb-0"
        >
            <div class="card-body border-0 rounded-0 d-flex justify-content-between align-items-center p-2 bg-warning" v-html="notification.message"></div>
        </div>
    </Vue3Marquee>-->
    <!--<li class="nav-item dropdown me-5">
        <Vue3Marquee :pause-on-hover="true" :duration="40" class="ms-3 me-3">
            <div
                v-for="notification in notifications"
                class="card me-2 mb-0"
            >
                <div class="card-body border-0 rounded-0 d-flex justify-content-between align-items-center p-2 bg-warning" v-html="notification.message"></div>
            </div>
        </Vue3Marquee>
    </li>-->
    <li class="nav-item dropdown">
        <a class="nav-link nav-icon" href="#" data-bs-toggle="dropdown" aria-expanded="false">
            <i class="bi bi-calendar-event"></i>
            <span class="badge bg-danger badge-number">{{ notifications.length }}</span>
        </a><!-- End Notification Icon -->
        <ul class="dropdown-menu dropdown-menu-end dropdown-menu-arrow notifications">
            <li class="dropdown-header">
                You have {{ notifications.length }} new notifications
                <!--<a v-if="notifications.length" class="cursor-pointer" @click="markAllAsRead"><span class="badge rounded-pill bg-theme p-2 ms-2">Mark all as read</span></a>-->
            </li>
            <li v-if="notifications.length">
                <hr class="dropdown-divider">
            </li>
            <template v-for="(notification, index) in notifications">
                <li class="notification-item">
                    <i class="bi bi-exclamation-circle text-warning"></i>
                    <div>
                        <p v-html="notification.message"></p>
                        <p>{{ formatTime(notification.created_at) }}</p>
                    </div>
                </li>
                <!--Check if index is not last item then show the divider-->
                <li v-if="index > notifications.length - 1"><hr class="dropdown-divider"></li>
            </template>
            <!--<li v-if="notifications.length" class="dropdown-footer">
                <a href="#">Show all notifications</a>
            </li>-->
        </ul>
    </li>
</template>
<script>
import { Vue3Marquee } from 'vue3-marquee'
import moment from 'moment';
export default {
    components: {
        Vue3Marquee,
    },
    data() {
        return {
            notifications: []
        }
    },
    created() {
        this.getNotifications();
    },
    methods: {
        getNotifications() {
            axios.post('/admin/appointments/notifications')
                .then(response => {
                    this.notifications = response.data.notifications;
                })
        },
        formatTime(time) {
            return moment(time).fromNow();
        },
        formatNotificationKey(key) {
            // Replace underscores with spaces and split the string into words
            const words = key.replace(/_/g, ' ').split(' ');

            // Capitalize the first letter of each word
            const capitalizedWords = words.map(word => word.charAt(0).toUpperCase() + word.slice(1));

            // Join the words back into a single string
            return capitalizedWords.join(' ');
        },
        markAllAsRead() {
            //Get the notification ids
            const notificationIds = this.notifications.map(notification => notification.id);
            axios.post('/admin/profile/notification-mark-as-read', {notification_ids: notificationIds})
                .then(response => {
                    this.getNotifications();
                })
        }
    },
}
</script>
